export enum DigitalizationProjectDetailsTab {
  INFORMATION = 'information',
  SETTINGS = 'settings',
  COWORKERS = 'coworkers',
  UPLOADS = 'uploads',
  DOCUMENTS = 'documents',
  IBL = 'ibl',
}
